import {Box, SxProps, Theme} from '@mui/material';
import {forwardRef} from 'react';
import {Outlet} from 'react-router';
import {PropsWithOptionalChildren} from '../react/types';
import {Footer, FooterProps} from './Footer';
import {useLayoutOffset} from './hooks/useLayoutOffset';

export interface ContentProps extends PropsWithOptionalChildren, Pick<FooterProps, 'withAppInstallPrompt'> {
  outletSx?: SxProps<Theme>;
  sx?: SxProps<Theme>;
}

export const Content = forwardRef<HTMLDivElement, ContentProps>(
  ({children, outletSx, sx, withAppInstallPrompt}: ContentProps, ref) => {
    const {horizontalOffset, verticalOffset} = useLayoutOffset();
    return (
      <Box
        component="main"
        ref={ref}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          minHeight: `calc(100vh - ${verticalOffset}px)`,
          ml: `${horizontalOffset}px`,
          mt: `${verticalOffset}px`,
          width: `calc(100% - ${horizontalOffset}px)`,
          ...sx,
        }}
      >
        <Box component="main" role="main" sx={{display: 'flex', flexDirection: 'column'}}>
          {children}
          <Box sx={outletSx}>
            <Outlet />
          </Box>
        </Box>
        <Footer withAppInstallPrompt={withAppInstallPrompt} />
      </Box>
    );
  },
);
Content.displayName = 'Content';
